import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const MeetingTypes = withSafeSuspense(lazy(
  async () => ({ default: (await import('./meeting_types')).MeetingTypes })
))
